import type { CallAnalysisExecutiveSynthesis, CallAnalysisRecommendedNextActionDetails } from '@marnic/shared';

interface Props {
  synthesis: CallAnalysisExecutiveSynthesis | null;
  fallbackSummary: string | null;
}

export function ExecutiveSummaryCard({ synthesis, fallbackSummary }: Props): JSX.Element | null {
  const summary = synthesis?.executiveSummary ?? fallbackSummary ?? null;
  if (!summary && !synthesis?.recommendedNextAction && !synthesis?.recommendedNextActionDetails) return null;

  // recommendedNextActionDetails is the v2.1 object form; recommendedNextAction
  // is the back-compat string. Prefer the object when present.
  const rawDetails = (synthesis as unknown as { recommendedNextActionFull?: CallAnalysisRecommendedNextActionDetails })
    ?.recommendedNextActionFull;
  const details = synthesis?.recommendedNextActionDetails ?? rawDetails;
  const actionString = synthesis?.recommendedNextAction ?? null;

  return (
    <div className="space-y-2">
      {summary && <p className="text-xs leading-relaxed">{summary}</p>}

      {(details || actionString) && (
        <div className="rounded border border-emerald-100 bg-emerald-50 px-2 py-1.5 text-xs text-emerald-900 space-y-0.5">
          <div className="text-[10px] font-semibold uppercase tracking-wide text-emerald-700">Next action</div>
          {details ? (
            <>
              <div className="font-medium">{details.action}</div>
              <div className="flex flex-wrap gap-2 text-[11px] text-emerald-800">
                {details.owner && <span>Owner: {details.owner}</span>}
                {details.deadline && <span>Deadline: {details.deadline}</span>}
              </div>
              {details.why && <div className="text-[11px] text-emerald-800 italic">{details.why}</div>}
            </>
          ) : (
            <div>{actionString}</div>
          )}
        </div>
      )}

      {synthesis?.coachingSummary && (
        <p className="text-[11px] italic text-ink-600">Coaching: {synthesis.coachingSummary}</p>
      )}
    </div>
  );
}
